import { createFileRoute } from "@tanstack/react-router";
import { BaseManagementPage } from "../../../pages/steering-page/base-management-page";

export const Route = createFileRoute("/_auth/_frame/steering")({
  component: BaseManagementPage,
});
